import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress "ResizeObserver loop completed with undelivered notifications" warning
if (typeof window !== 'undefined') {
  const suppressResizeObserverError = () => {
    const handler = (event) => {
      const message = event.message || event.error?.message;
      if (message === 'ResizeObserver loop completed with undelivered notifications.' ||
        message === 'ResizeObserver loop completed with undelivered notifications') {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };
    window.addEventListener('error', handler, true);
    return () => window.removeEventListener('error', handler, true);
  };

  suppressResizeObserverError();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals(console.log);